import { ISelectionSetAction, CursorPosition } from '@engoo/realtime-protocol/selection';
import { KeyPath } from 'app/models/entityStateSync/keypath';
import { List, Map, Record } from 'immutable';

/**
 * Local representation of the selection, with concrete types for paths
 */
export interface ISelection extends Omit<ISelectionSetAction, 'paths' | 'type'> {
  readonly paths: List<KeyPath>;
  readonly user: string;
}

export class Selection extends Record<ISelection>({
  paths: List(),
  user: '',
  color: '',
  cursorPosition: CursorPosition.Start,
  startOffset: 0,
  endOffset: 0,
}) {
  public constructor(props: ISelection) {
    super(props);
  }
}

export type ParticipantSelections = Map<string, Selection>;

export interface ISelectionAreaContext {
  readonly addDiscoveryNode: (path: KeyPath, node: HTMLElement, block: boolean) => void;
  readonly removeDiscoveryNode: (path: KeyPath) => void;
}

export class SharedSelectionDocumentState extends Record<{
  selections: ParticipantSelections,
}>({
  selections: Map(),
}) {}
